/* eslint-disable no-unused-vars */
/* eslint-disable import/no-cycle */
import React, { useState, Fragment } from "react";
import {
    Paper, TableContainer, Table, TableCell, TableFooter, TableHead, TableRow, TableBody, TablePagination,
} from "@mui/material";

import {
    useForm, useWatch,
} from "react-hook-form";
import { useTheme } from "@mui/material/styles";
// eslint-disable-next-line import/no-cycle
import { DragDropContext, Draggable } from "react-beautiful-dnd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as MUITable from "@mui/material";
import { TableVirtuoso } from "react-virtuoso";
import PTMEditTableEntry from "./PTMEditTableEntry";
// eslint-disable-next-line import/no-cycle
import PTMEditTableMultiLineEntry from "./PTMEditTableMultiLineEntry";
import StrictModeDroppable from "../StrictModeDroppable";
import PTMEditTableEntryDraggable from "./PTMEditTableEntryDraggable";
import PTMEditTableMultiLineEntryDraggable from "./PTMEditTableMultiLineEntryDraggable";

const TableComponents = {
    Scroller: React.forwardRef((props, ref) => (
        <MUITable.TableContainer
            component={MUITable.Paper}
            {...props}
            ref={ref}
        />
    )),
    Table: (props) => <MUITable.Table {...props} style={{ borderCollapse: "separate" }} />,
    TableHead: MUITable.TableHead,
    TableRow: MUITable.TableRow,
    TableBody: React.forwardRef((props, ref) => <MUITable.TableBody {...props} ref={ref} />),
};

function PTMEditTable(props) {
    const {
        columns,
        rows,
        removeHandler,
        saveHandler,
        restoreHandler,
        expandHandler,
        dropdownContent,
        multiLine,
        pagination,
        shortWidth,
        customActionButtons,
        draggable,
        onReorder,
        excludedActions,
        disabledActions,
        addToIsDirtyArray,
        removeFromIsDirtyArray,
        selectable,
        selectHandler,
        selectedEntries,
        lockedProp,
        lockedValue,
        actionControls,
        canDeleteInactive,
        stickyTable,
        setEditCount,
        editCount,
        customActionButtonsPosition,
    } = props;

    const [fetchedRows, setFetchedRows] = useState(rows);

    const ref = React.useRef(null);

    const theme = useTheme();

    const { innerHeight: pageHeight } = window;

    const componentId = React.useId();
    const scrollOptions = React.useRef({
        lock: false,
        position: {
            left: 0,
            top: 0,
        },
    });

    React.useEffect(() => {
        if (editCount > 0) {
            if (!scrollOptions.current.lock) {
                setTimeout(() => {
                    if (draggable) {
                        ref?.current?.scrollIntoView({
                            behaviour: "instant",
                            block: "end",
                            inline: "end",
                        });
                    } else {
                        ref?.current?.scrollToIndex({
                            index: rows.length,
                            align: "end",
                            behavior: "instant",
                        });
                    }
                    setTimeout(() => {
                        scrollOptions.current.lock = true;
                    }, 50);
                }, 250);
            }
        } else {
            scrollOptions.current.lock = false;
        }
    }, [editCount, rows]);

    function Pagination() {
        return (
            <TablePagination
                component="div"
                rowsPerPageOptions={[]}
                colSpan={7}
                count={pagination?.count}
                rowsPerPage={pagination?.rowsPerPage || 50}
                page={pagination?.page}
                onPageChange={pagination.change}
            />
        );
    }

    const {
        control,
        reset,
        formState: { errors },
    } = useForm({
        mode: "onChange",
        defaultValues: {
            editRows: [],
        },
    });

    const addRow = (element) => {
        const newRows = [...fetchedRows];
        newRows.push({
            tmp_id: newRows.length + 1,
            is_new: true,
            salutation: "",
            secondary_salutation: "",
            is_female: false,
            letter_salutation: "",
        });

        setFetchedRows(newRows);
    };

    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };

    const onDragEnd = (result) => {
        if (!result.destination) return;
        const items = reorder(
            rows,
            result.source.index,
            result.destination.index,
        );
        onReorder(items);
    };

    const draggableBody = () => (
        <DragDropContext onDragEnd={onDragEnd}>
            <StrictModeDroppable droppableId="ptm-edit-table">
                {
                    (provided) => (
                        <TableBody
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                        >
                            {multiLine ? (
                                rows.map((row) => (
                                    <PTMEditTableMultiLineEntryDraggable
                                        key={row.id || row.tmp_id || row.tmpId}
                                        row={row}
                                        isActive={row.is_active === 1}
                                        saveHandler={saveHandler}
                                        columns={columns}
                                        removeHandler={removeHandler}
                                        restoreHandler={restoreHandler}
                                        addToIsDirtyArray={addToIsDirtyArray}
                                        removeFromIsDirtyArray={removeFromIsDirtyArray}
                                        setEditCount={setEditCount}
                                    />
                                ))
                            ) : (
                                rows?.map((row, i) => {
                                    const labelId = row.id || row.tmp_id || row.tmpId || row.ata_id;
                                    return (
                                        <Draggable
                                            key={labelId}
                                            index={i}
                                            draggableId={labelId.toString()}
                                            isDragDisabled={row.is_new}
                                        >
                                            {(providedRow) => (
                                                <PTMEditTableEntryDraggable
                                                    draggableProps={providedRow}
                                                    isActive={row.is_active === 1}
                                                    saveHandler={saveHandler}
                                                    columns={columns}
                                                    removeHandler={removeHandler}
                                                    expandHandler={expandHandler}
                                                    dropdownContent={dropdownContent}
                                                    restoreHandler={restoreHandler}
                                                    rows={rows}
                                                    element={row}
                                                    shortWidth={shortWidth}
                                                    customActionButtons={customActionButtons}
                                                    excludedActions={excludedActions}
                                                    disabledActions={disabledActions}
                                                    addToIsDirtyArray={addToIsDirtyArray}
                                                    removeFromIsDirtyArray={removeFromIsDirtyArray}
                                                    selectable={selectable}
                                                    selectHandler={selectHandler}
                                                    selectedEntries={selectedEntries}
                                                    lockedProp={lockedProp}
                                                    lockedValue={lockedValue}
                                                    actionControls={actionControls}
                                                    canDeleteInactive={canDeleteInactive}
                                                    setEditCount={setEditCount}
                                                    i={i}
                                                    customActionButtonsPosition={customActionButtonsPosition || "start"}
                                                />
                                            )}
                                        </Draggable>

                                    );
                                })
                            )}
                        </TableBody>
                    )
                }
            </StrictModeDroppable>
        </DragDropContext>
    );

    return (
        <Paper sx={{ overflow: "hidden", width: "100%", height: "100%" }} elevation={0}>
            <>
                {draggable ? (
                    <TableContainer
                        sx={{
                            height: stickyTable ? (pageHeight * 80) / 100 : "100%",
                            "& th": { backgroundColor: stickyTable && theme.palette.background.paper },
                        }}
                    >
                        <Table
                            ref={ref}
                            stickyHeader={stickyTable}
                            sx={{
                                margin: "0 auto",
                                marginTop: "5px",
                                "& .MuiTableCell-head": {
                                    fontSize: "15px",
                                    paddingLeft: "10px !important",
                                    marginBottom: "5px",

                                },
                                "& .MuiTableBody-root": {
                                    verticalAlign: "middle",
                                    "& .MuiTableRow-root": {
                                        height: "35px",
                                        paddingRight: "10px",
                                        "&:nth-of-type(odd)": {
                                            backgroundColor: theme.palette.action.hover,
                                        },
                                        "& .MuiTableCell-root": {
                                            verticalAlign: "middle !important",
                                            padding: "0 10px !important",
                                        },
                                    },
                                },
                            }}
                        >
                            <TableHead>
                                <TableRow>

                                    {selectable
                                        && (
                                            <TableCell width={130} />
                                        )}
                                    <TableCell width={130}>
                                        Aktionen
                                    </TableCell>
                                    {columns.filter((column) => !column.hideField).map((column) => (
                                        <TableCell
                                            width={column.width}
                                            sx={column?.columnTitleStyle}
                                            key={column?.name}
                                        >
                                            {column?.icon
                                                && <FontAwesomeIcon icon={column?.icon} style={column?.iconStyle} />}
                                            {" "}
                                            {column?.name}
                                        </TableCell>
                                    ))}
                                    {
                                        shortWidth
                                        && <TableCell />
                                    }
                                </TableRow>
                            </TableHead>
                            {draggableBody()}
                            {pagination?.enabled && !stickyTable
                                && (
                                    <TableFooter>
                                        <TableRow>
                                            <Pagination />
                                        </TableRow>
                                    </TableFooter>
                                )}
                        </Table>
                    </TableContainer>
                ) : (
                    <TableVirtuoso
                        ref={ref}
                        scrollerRef={(scroller) => {
                            if (scroller?.getAttribute(`virtuoso-scroll-${componentId}`) !== "added") {
                                scroller?.addEventListener("scroll", (e) => {
                                    scrollOptions.current.position.left = e.target.scrollLeft;

                                    if (scrollOptions.current.lock) {
                                        e.target.scrollTo(scrollOptions.current.position.left, scrollOptions.current.position.top);
                                    } else {
                                        scrollOptions.current.position.top = e.target.scrollTop;
                                    }
                                });
                                scroller?.setAttribute(`virtuoso-scroll-${componentId}`, "added");
                            }
                        }}
                        style={{ height: `calc(100% - ${pagination?.enabled ? "18px" : "0px"})` }}
                        data={rows}
                        components={TableComponents}
                        overscan={800}
                        fixedHeaderContent={() => (
                            <TableRow>

                                {selectable
                                    && (
                                        <TableCell width={130} />
                                    )}
                                <TableCell
                                    width={130}
                                    sx={{
                                        background: theme.palette.background.paper,
                                    }}
                                >
                                    Aktionen
                                </TableCell>
                                {columns.filter((column) => !column.hideField).map((column) => (
                                    <TableCell
                                        width={column.width}
                                        sx={{
                                            ...column?.columnTitleStyle,
                                            background: theme.palette.background.paper,
                                        }}
                                        key={column?.name}
                                    >
                                        {column?.icon
                                            && <FontAwesomeIcon icon={column?.icon} style={column?.iconStyle} />}
                                        {" "}
                                        {column?.name}
                                    </TableCell>
                                ))}
                                {
                                    shortWidth
                                    && <TableCell />
                                }
                            </TableRow>
                        )}
                        itemContent={(index, row) => (multiLine
                            ? (
                                <PTMEditTableMultiLineEntry
                                    key={row.id || row.tmp_id || row.tmpId}
                                    row={row}
                                    isActive={row.is_active === 1}
                                    saveHandler={saveHandler}
                                    columns={columns}
                                    removeHandler={removeHandler}
                                    restoreHandler={restoreHandler}
                                    addToIsDirtyArray={addToIsDirtyArray}
                                    removeFromIsDirtyArray={removeFromIsDirtyArray}
                                    setEditCount={setEditCount}
                                />

                            ) : (
                                <Fragment key={row.id || row.tmp_id || row.tmpId}>
                                    <PTMEditTableEntry
                                        isActive={row.is_active === 1}
                                        saveHandler={saveHandler}
                                        columns={columns}
                                        removeHandler={removeHandler}
                                        expandHandler={expandHandler}
                                        dropdownContent={dropdownContent}
                                        restoreHandler={restoreHandler}
                                        rows={rows}
                                        element={row}
                                        shortWidth={shortWidth}
                                        customActionButtons={customActionButtons}
                                        excludedActions={excludedActions}
                                        disabledActions={disabledActions}
                                        addToIsDirtyArray={addToIsDirtyArray}
                                        removeFromIsDirtyArray={removeFromIsDirtyArray}
                                        selectable={selectable}
                                        selectHandler={selectHandler}
                                        selectedEntries={selectedEntries}
                                        lockedProp={lockedProp}
                                        lockedValue={lockedValue}
                                        actionControls={actionControls}
                                        canDeleteInactive={canDeleteInactive}
                                        setEditCount={setEditCount}
                                        i={index}
                                        customActionButtonsPosition={customActionButtonsPosition || "start"}
                                    />
                                </Fragment>

                            ))}
                    />
                )}
                {
                    pagination?.enabled
                    && <Pagination />
                }
            </>
        </Paper>
    );
}

export default PTMEditTable;
